const Rotate = ({
  isShow,
  isAddedImage,
  rotateChangeHandler,
  canvasRotationAngle,
  canvasDimensionWidth,
  canvasDimensionHeight,
}: {
  isShow: boolean;
  isAddedImage: boolean;
  rotateChangeHandler: Function;
  canvasRotationAngle: number;
  canvasDimensionWidth: number;
  canvasDimensionHeight: number;
}): JSX.Element => {
  if (!isShow) return <></>;

  return (
    <form className="service__control-form service__control-form form form__rotate">
      <div className="form__group_btn">
        <button
          type="button"
          style={{ fontSize: 0 }}
          disabled={!isAddedImage}
          onClick={() =>
            rotateChangeHandler(
              false,
              canvasRotationAngle,
              canvasDimensionWidth,
              canvasDimensionHeight
            )
          }
        >
          Rotate Left
          <i className="icon__rotate-left" />
        </button>
        <span>Rotate Left</span>
      </div>
      <div className="form__group_btn left">
        <button
          type="button"
          style={{ fontSize: 0 }}
          disabled={!isAddedImage}
          onClick={() =>
            rotateChangeHandler(
              true,
              canvasRotationAngle,
              canvasDimensionWidth,
              canvasDimensionHeight
            )
          }
        >
          Rotate Right
          <i className="icon__rotate-right" />
        </button>
        <span>Rotate Right</span>
      </div>
    </form>
  );
};

export default Rotate;
